
















































































































































// eslint-disable-next-line no-unused-vars
import Vue, { PropType } from 'vue';
import { gsap } from 'gsap';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { mapState } from 'vuex';
// import { checkUser } from '@/api/profile';
// eslint-disable-next-line no-unused-vars
import { conferenceType, motionsType, profileType } from '@/types/api';

gsap.registerPlugin(ScrollTrigger);

export default Vue.extend({
  name: 'confDetails',
  props: {
    sel: Number,
    confData: Object as PropType<conferenceType.getConference>,
    ongoing: Boolean,
    transEnd: Boolean,
  },
  data() {
    return {
      tl: null as GSAPTimeline | null,
      motionsData: [] as motionsType.getMotions[],
      chairman: [] as {first_name: string, last_name: string}[],
    };
  },
  mounted() {
    this.scroll();
  },
  created() {
    if (this.confData.motions) {
      this.confData.motions.batches.forEach((motion) => {
        this.motionsData.push(...motion.batch_motions);
      });
    }
    this.confData.chairman.forEach(() => {
      const response = this.check();
      const res: {first_name: string, last_name: string} = {
        first_name: response.user_name.first_name.charAt(0).toUpperCase()
      + response.user_name.first_name.slice(1),
        last_name: response.user_name.last_name.charAt(0).toUpperCase()
      + response.user_name.last_name.slice(1),
      };
      this.chairman.push(res);
    });
  },
  beforeUpdate() {
  },
  methods: {
    // async check(user: string): Promise<profileType.checkUser> {
    check(): profileType.checkUser {
      const data = {
        email: 'johndoe@example.com',
        found: true,
        user_name: {
          first_name: 'John',
          last_name: 'Doe',
        },
      };
      // const u = await checkUser(data);
      return data;
    },
    buildExcel(): void {
      const wb = XLSX.utils.book_new();
      // ROLLCALL WS
      const data: (number | string)[][] = [['Country', 'Present', 'Present & Voting']];
      this.confData.delegates.forEach((delegate) => {
        data.push([
          delegate.country,
          delegate.status.toLowerCase() === 'present' ? 1 : 0,
          delegate.status.toLowerCase() === 'present & voting' ? 1 : 0,
        ]);
      });
      const rollCallWS = XLSX.utils.aoa_to_sheet(data);
      const rows = this.confData.delegates.length;
      const rollCallRange = {
        s: { r: 0, c: 0 },
        e: { r: rows + 3, c: 3 },
      };

      rollCallWS['!ref'] = XLSX.utils.encode_range(rollCallRange);
      rollCallWS[`A${rows + 2}`] = { v: '' };
      rollCallWS[`B${rows + 2}`] = { f: `SUM(B2:B${rows})` }; // present total
      rollCallWS[`C${rows + 2}`] = { f: `SUM(C2:C${rows})` }; // present & voting total
      rollCallWS[`A${rows + 4}`] = { v: 'Simple Majority' };
      rollCallWS[`B${rows + 4}`] = { f: `SUM(B${rows + 2}:C${rows + 2})*50%` };

      XLSX.utils.book_append_sheet(wb, rollCallWS, 'Roll Call');

      // RULES WS
      const rules: any[] = [
        ['Present'],
        ['Present & Voting'],
        ['Total'],
        '',
        [`Majority Vote (${this.confData.rules.majority})`],
        [`Quorum Vote (${this.confData.rules.quorum})`],
        '',
        // ['Moderated Caucus', // TODO: add time rules
        // `${this.confData.caucus.list[0].total_time / 60}
        // minutes total time & ${this.confData.caucus.list[0].speaking_time} speaking time`],
        // ['Unmoderated Caucus'],
      ];

      const rulesRange = {
        s: { r: 0, c: 0 },
        e: { r: 5, c: 1 },
      };

      const rulesWS = XLSX.utils.aoa_to_sheet(rules);
      rulesWS['!ref'] = XLSX.utils.encode_range(rulesRange);
      rulesWS.B1 = { f: `'Roll Call'!B${rows + 2}` };
      rulesWS.B2 = { f: `'Roll Call'!C${rows + 2}` };
      rulesWS.B3 = { f: 'SUM(B1:B2)' };
      rulesWS.B5 = { f: '(B3/2)+1' }; // TODO: custom maojrity rule
      rulesWS.B6 = { f: 'ROUNDUP(B3*30%)' }; // TODO: custom quorum rule & Rounding

      XLSX.utils.book_append_sheet(wb, rulesWS, 'Rules');

      // GSL WS
      const gsl: (string | number)[][] = [
        ['No', 'Country', 'Time', 'Yield', 'Yield'],
        ['', '', 'Min', 'Sec', 'Yield', 'Yield'],
      ];
      if (this.confData.gsl) {
        for (let i = 0; i < this.confData.gsl.length; i += 1) {
          gsl.push([i + 1, '', this.confData.gsl.queue[i].time_left, 'Yield to']);
        } // TODO: delegate, time minute, & yield to
      }

      const gslWS = XLSX.utils.aoa_to_sheet(gsl);
      const merge = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // no
        { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // country
        { s: { r: 0, c: 2 }, e: { r: 0, c: 3 } }, // time
        { s: { r: 0, c: 4 }, e: { r: 1, c: 5 } }, // yield
      ];
      gslWS['!merges'] = merge;
      XLSX.utils.book_append_sheet(wb, gslWS, 'GSL');

      // TODO: Formal Debate WS

      const wbout = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
      /* create data URL */
      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, `${this.confData.title}.xlsx`);
    },
    scroll(): void {
      ScrollTrigger.matchMedia({
        '(max-width: 960px)': () => {
          ScrollTrigger.create({
            trigger: '.nav',
            start: 'bottom top',
            endTrigger: '.details',
            end: 'bottom top',
            pinSpacing: false,
            pin: '#pin',
          });
          this.tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.nav',
              start: 'bottom top',
              endTrigger: '.details',
              end: 'top top',
              scrub: true,
            },
          });
          this.tl.fromTo('.upper .exportEdit', {
            autoAlpha: 1,
            scaleX: 1,
          }, {
            autoAlpha: 0,
            scaleX: 0.5,
          }, 0)
            .fromTo('#pin', {
              scaleY: 1,
              boxShadow: '0 0 20px 0 rgba(0,0,0,0)',
              borderRadius: '0',
            }, {
              scaleY: 0.5,
              boxShadow: '0 0 20px 0 rgba(0,0,0,0.15)',
              borderRadius: '0 0 15px 15px',
            }, 0)
            .fromTo('.upper .left', {
              scaleX: 1,
            }, {
              scaleX: 0.5,
            }, 0);
          if (this.ongoing && typeof this.sel === 'number') {
            this.tl.to('#pin', {
              backgroundColor: '#5f78ff',
              boxShadow: '0 0 20px 0 #5f78ff',
              color: 'white',
            }, 0)
              .fromTo('.upper p.right', {
                autoAlpha: 0,
                scaleX: 1,
                scaleY: 1,
              }, {
                autoAlpha: 1,
                scaleY: 1.5,
                scaleX: 0.75,
              }, 0);
          }
        },
      });
    },
  },
  computed: {
    ...mapState({
      width: (state: any) => state.Global.widthWindow,
    }),
  },
  watch: {
    transEnd() {
      ScrollTrigger.refresh(true);
    },
  },
});
